CityGuideView = require './city_guide_view'

module.exports =
  init: () ->
    cityGuideView = new CityGuideView
    cityGuideView.render()

    $('.grid_toggle').click ->
      Groupon?.Utils?.lazyLoadImages?()
